import * as i18n from "util/i18n";
import { isUxTransfersImprovementsEnabled } from "util/v3ShellLayoutSync";

const V3_I18N_SUFFIX = ".v3";
const INTERNAL_TRANSFER_ACTIVITY_IDS = new Set([
    "transfers.internal.preview",
    "transfers.internal.send",
    "transfers.internal.tad.send",
]);
const INTERNAL_TRANSFER_ACTIVITY_FALLBACKS = {
    "transfers.internal.preview": "Transferencia a mis cuentas (Preview)",
    "transfers.internal.send": "Transferencia a mis cuentas",
    "transfers.internal.tad.send": "Transferencia diferida a mis cuentas",
};

export function getTransferUxI18nKey(baseKey) {
    return isUxTransfersImprovementsEnabled() ? `${baseKey}${V3_I18N_SUFFIX}` : baseKey;
}

export function getTransferUxLabel(baseKey, v3Fallback = null) {
    const key = getTransferUxI18nKey(baseKey);
    if (isUxTransfersImprovementsEnabled() && v3Fallback != null) {
        return i18n.get(key, v3Fallback);
    }
    return i18n.get(key);
}

export function isTransferUxI18nKey(key, baseKey) {
    return key === baseKey || key === `${baseKey}${V3_I18N_SUFFIX}`;
}

export function getTransferActivityName(idActivity, activityName) {
    if (!isUxTransfersImprovementsEnabled() || !INTERNAL_TRANSFER_ACTIVITY_IDS.has(idActivity)) {
        return activityName;
    }
    return i18n.get(`activities.${idActivity}${V3_I18N_SUFFIX}`, INTERNAL_TRANSFER_ACTIVITY_FALLBACKS[idActivity]);
}

export function getTransferInternalTitleI18nKey({ mobile = false } = {}) {
    const baseKey = mobile ? "transfers.form.internal.title.mb" : "transfers.form.internal.title";
    return getTransferUxI18nKey(baseKey);
}

export function getTransferInternalTitleLabel({ mobile = false } = {}) {
    return getTransferUxLabel(
        mobile ? "transfers.form.internal.title.mb" : "transfers.form.internal.title",
        mobile ? "Transferir a mis cuentas" : "A mis cuentas",
    );
}
